import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39122696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "object" }
const _hoisted_2 = { class: "object_image" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "object_text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "small" }, "mehr lesen", -1))
const _hoisted_6 = [
  _hoisted_5
]

import { CollectionObject } from "@/types";
import {defineAsyncComponent, ref} from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  object: {
    type: Object as () => CollectionObject,
    required: true
  }
},
  setup(__props) {

const props = __props

const ObjectInfo = defineAsyncComponent(() => import('@/components/screens/ObjectInfo.vue'))

let objectInfosOpen = ref<boolean>(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: __props.object.imagesource,
          alt: __props.object.imagealt
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(__props.object.title), 1),
        _createElementVNode("p", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(objectInfosOpen) //@ts-ignore
 ? objectInfosOpen.value = true : objectInfosOpen = true))
        }, _hoisted_6)
      ])
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_unref(objectInfosOpen))
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(ObjectInfo)), {
              key: 0,
              object: __props.object,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_isRef(objectInfosOpen) //@ts-ignore
 ? objectInfosOpen.value = false : objectInfosOpen = false))
            }, null, 8, ["object"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})